// Shared by world.ts and levels.ts
export const K = 'penguins';
export const DEG = Math.PI / 180;
export const SNOW = 0.9, GRAVEL = 0.98;           // drag per frame: snow brakes a lot, gravel a little, ice not at all
